module.exports = __webpack_public_path__ + "img/titulo.34db7343.svg";